import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const initialState = {
    isLoading: false,
};

export const commonSlice = createSlice({
    name: "common",
    initialState,
    reducers: {
      setToastMessage: (state, action) => {
        console.log(action.payload);
        if (action.payload.type === "info") {
            toast.info(action.payload.message, { position: "bottom-right", autoClose: 2000 });
        } 
        else if(action.payload.type === "success"){
          toast.success(action.payload.message, { position: "bottom-right", autoClose: 2000 });
        }
        else {
            toast.error(action.payload.message, { position: "bottom-right", autoClose: 2000 });
        }
      },
      setIsLoading: (state, action) => {
        state.isLoading = action.payload;
      }
    },
  });
  
  export const { setToastMessage, setIsLoading } = commonSlice.actions;
  export const selectCommonData = (state) => state.commonReducer;
  
  export default commonSlice.reducer;
